import React, { useState } from "react";
import { FilePreview, Row } from "./file-preview";
import { uploadExcelFile } from "./file-upload-handler";
import { PickFileButton } from "./PIckFileButton";
import { useAudience } from "./AudienceStore";
import { MessageBox } from "../comps/MessageBox";

type State = "pick-file" | "file-chosen" | "data-parsed"

export function PickFile(){
    const [state, setState] = useState<State>("pick-file")
    const [rows, setRows] = useState<Row[]>(null);

    async function onFile(file:File){
        setState("file-chosen");
        const result = await uploadExcelFile(file)
        console.log(result);
        setRows(result.members)
        setState("data-parsed");
    }

    return <>
        {state == 'pick-file' && <PickFileButton onFileChosen={onFile} />}
        {state == 'file-chosen' && <p>Processando arquivo</p>}
        {state == 'data-parsed' && <FilePreview rows={rows} />}
    </>
}

export function MemberImporter(){
    const audience = useAudience();
    return <>
        <h3>Público <small><i className="fa fa-chevron-right crumb-arrow"></i> {audience.name} <i className="fa fa-chevron-right crumb-arrow"></i> Importar Contatos</small></h3>
        <h5>Importação de contatos</h5>
        <MessageBox className="mt-4">
            Envie um arquivo de Excel <span className="badge bg-success">.xlsx</span>  ou <span className="badge bg-success">.csv</span> para importar novos dados de contato.
            <hr className="mx-450" />
            Lembre-se o arquivo deve conter uma linha de cabeçalho com o nome das colunas. 
            <hr className="mx-450" />
            O ideal é que você tenha ao menos 2 colunas (nome e telefone)<br />
            Todas as colunas poderão ser utilizadas como variáveis para compor a mensagem.<br />
            Uma coluna com o número de telefone é obrigatória.
        </MessageBox>
        <PickFile />
    </>
}